import { Plus } from 'lucide-react';
import { DataTable } from '../../../../../design-system/data-table/data-table';
import { EmployeeView } from '../../../../../types/entity-types';
import { employeeTableColumnDefinition } from './employee-table-column-definitions';

type EmployeeTableProps = {
  employees: EmployeeView[];
  onEditEmployee?: (employeeId: string) => void;
  onAddEmployee: () => void;
};

export const EmployeeTable = ({ employees, onEditEmployee, onAddEmployee }: EmployeeTableProps) => {
  return (
    <DataTable<EmployeeView>
      columns={employeeTableColumnDefinition}
      data={employees}
      className="flex-1"
      meta={{
        rowHeight: 76,
        onEditEmployee,
      }}
      tableActionButtonConfig={{
        primary: {
          isVisible: true,
          text: 'Add Employee',
          onClick: onAddEmployee,
          icon: <Plus />,
        },
        secondary: {
          isVisible: false,
        },
      }}
    />
  );
};
